import { EXPENSES_RECIEVED, EXPENSE_SAVED, EXPENSE_DELETED, EXPENSE_UNLOADED } from './types'

export default function expenses(state = [], action = {}){
  switch (action.type) {
    case EXPENSES_RECIEVED:
      return action.data.sort(function(a, b) {
        let result = 0 
        let aStart = a.bars && a.bars[0] ? parseInt(a.bars[0].startDate, 10) : 0
        let bStart = b.bars && b.bars[0] ? parseInt(b.bars[0].startDate, 10) : 0
        result =  (a.itemType.localeCompare(b.itemType)) || (aStart-bStart) || (parseInt(a.balance, 10) - parseInt(b.balance, 10)) || (a.description.localeCompare(b.description))
        return result
      })
    case EXPENSE_UNLOADED:
      return []
    case EXPENSE_SAVED:
    let isEdit = false
    const _state = state.map( v => {
      if(v.id === action.data.id){
        isEdit = true
        return action.data
      }else{
        return v
      }
    })
    if(!isEdit){
      return [action.data, ...state]
    }else{
      return _state
    }
    case EXPENSE_DELETED:
      return state.filter( v => v.id !== action.data.id )
    default:
      return state
  }
}
